import { generateDocumentName, getUnbakedPcbLayoutNodes, PermissionType, } from "@buildwithflux/models";
/**
 * @deprecated use createPartVersionFromDocument in lifycycle.ts instead
 */
export function createNewPartVersionData(ownerUid, organizationOwnerUid, enterpriseOwnerUid, enterpriseOwnerHandle, organizationOwnerIsEnterpriseDefault, partUid, version, partName, documentState, documentImportUid, localToDocumentUid) {
    const name = partName || generateDocumentName();
    if (!version) {
        throw new Error(`Creating part version for ${partUid}, but its key is empty`);
    }
    let partVersionData = {
        part_uid: partUid,
        name,
        owner_uid: ownerUid,
        version,
        created_at: new Date().getTime(),
        terminals: {},
        properties: {},
        controls: [],
        pcbLayoutRuleSets: {},
        pcbLayoutNodes: {},
        assets: {},
    };
    if (documentImportUid) {
        partVersionData = {
            ...partVersionData,
            document_import_uid: documentImportUid,
        };
    }
    if (organizationOwnerUid) {
        partVersionData = {
            ...partVersionData,
            organization_owner_uid: organizationOwnerUid,
            organization_member_permission_type: PermissionType.edit,
        };
    }
    if (enterpriseOwnerUid) {
        partVersionData = {
            ...partVersionData,
            enterprise_owner_uid: enterpriseOwnerUid,
            enterprise_member_permission_type: PermissionType.edit,
        };
    }
    if (documentState?.properties) {
        partVersionData.properties = documentState.properties;
    }
    if (documentState?.controls) {
        partVersionData.controls = documentState.controls;
    }
    if (documentState?.pcbLayoutRuleSets) {
        partVersionData.pcbLayoutRuleSets = documentState.pcbLayoutRuleSets;
    }
    if (documentState?.pcbLayoutNodes) {
        partVersionData.pcbLayoutNodes = getUnbakedPcbLayoutNodes(documentState);
    }
    if (documentState?.assets) {
        partVersionData.assets = documentState.assets;
    }
    if (documentState?.has_custom_name) {
        partVersionData.has_custom_name = documentState.has_custom_name;
    }
    if (partName === "Terminal") {
        partVersionData.description = "Terminal";
        partVersionData.symbol_resource_file = "assets/terminal.glb";
    }
    if (localToDocumentUid) {
        partVersionData.localToDocumentUid = localToDocumentUid;
    }
    return partVersionData;
}
//# sourceMappingURL=factory.js.map